package ru.it_mozaika.sender.common.models

import kotlinx.serialization.Serializable


@Serializable
data class TriggerTitle(
    val id: String,
    val name: String,
    val oneTimeExecution: Boolean,
    val store: String,
    val category: String,
    val status: TriggerStatus
)

@Serializable
enum class TriggerStatus(val ruTitle: String) {
    Template("Черновик"),
    Started("Запущен")
}

@Serializable
data class TriggerCategory(
    val id: String,
    val store: String,
    val name: String,
    var mailsLimit: Int = 0,
    var limitPeriod: Long = 0L
)

@Serializable
data class Trigger(
    val id: String,
    val store: String,
    val category: String,
    val name: String,
    val oneTimeExecution: Boolean,
    val status: TriggerStatus,
    val eventsToStop: List<TriggerEvent>,
    val steps: List<TriggerStep>,
    val stats: List<TriggerStepStatistics>,
)

@Serializable
sealed class UpdateTriggerStepRequest {
    @Serializable
    data class UpdateStepRequest(val step: TriggerStep) : UpdateTriggerStepRequest()

    @Serializable
    data class UpdateDelayRequest(val delay: Long = -1, val randomDelay: Long = 0L) : UpdateTriggerStepRequest()

    @Serializable
    data class EmailAttachment(
        val name: String,
        val url: String
    )
    @Serializable
    data class UpdateEmailAttachmentsRequest(val attachments: List<EmailAttachment> = listOf()) : UpdateTriggerStepRequest()
}

@Serializable
data class TriggerStepPosition(
    var x: Float = 0.0f,
    var y: Float = 0.0f,
)

@Serializable
data class TriggerStep(
    val id: Int,
    val position: TriggerStepPosition,
    val connections: List<Set<Int>>,
    val delay: Long = -1L,
    val randomDelay: Long = 0L,
    val type: TriggerStepType
)

@Serializable
sealed class TriggerStepType {

    @Serializable
    data class StartTriggerStep(
        var event: TriggerEvent = TriggerEvent.AbandonedBasket,
    ) : TriggerStepType()

    @Serializable
    data class TargetTriggerStep(
        var title: String = "",
        var stopTrigger: Boolean = true,
    ) : TriggerStepType()

    @Serializable
    data class FilterTriggerStep(
        var rules: Rule.RuleGroup = Rule.RuleGroup(),
    ) : TriggerStepType()

    @Serializable
    data class EmailTriggerStep(
        var subject: String = "",
        var template: EmailTemplate = EmailTemplate.Freemarker(),
        var sender: String = "",
        var attachments: List<File> = listOf()
    ) : TriggerStepType()

    @Serializable
    data class ConditionTriggerStep(
        var event: TriggerEvent = TriggerEvent.AbandonedBasket,
    ) : TriggerStepType()

    @Serializable
    data class ActionTriggerStep(
        var action: TriggerAction = TriggerAction.Subscribe(),
    ) : TriggerStepType()
}


@Serializable
sealed class TriggerAction {
    @Serializable
    data class Subscribe(var store: String = "", var lists: List<String> = listOf()) : TriggerAction()
    @Serializable
    data class Unsubscribe(var store: String = "", var lists: List<String> = listOf()) : TriggerAction()
    @Serializable
    data class SendEmail(var sender: String = "", var email: String = "", var subject: String = "", var body: String = "<html></html>") : TriggerAction()
    @Serializable
    data class Separate(var percent: Int = 50) : TriggerAction()
    @Serializable
    data class HttpRequest(var url: String = "", var getRequest: Boolean = true, var params: List<Pair<String, String>> = listOf(), var headers: Map<String, String> = mapOf(), var body: String? = null) : TriggerAction()
}

@Serializable
sealed class TriggerEvent {

    @Serializable
    data class AddSubscriber(
        var isNewSubscriber: Boolean = false,
        var subscriptionListIds: List<String> = listOf()
    ) : TriggerEvent()

    @Serializable
    object AbandonedBasket : TriggerEvent()

    @Serializable
    object BasketProductPriceDrop : TriggerEvent()
    @Serializable
    object ProductsReturnToStore : TriggerEvent()
    @Serializable
    object Order : TriggerEvent()
}

@Serializable
data class TriggerStepStatistics(
    val step: Int,
    var invokeCount: Int,
    var typedStats: TriggerTypedStepStatistics? = null
)

@Serializable
sealed class TriggerTypedStepStatistics {

    @Serializable
    data class ConditionStepStatistics(
        var trueInvokedCount: Int = 0
    ) : TriggerTypedStepStatistics()

    @Serializable
    data class EmailStepStatistics(
        var send: Int = 0,
        var delivery: Int = 0,
        var read: Int = 0,
        var click: Int = 0
    ) : TriggerTypedStepStatistics()
}